import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { COMMON_NAMESPACE } from '@/i18n';
import '@/Pages/Selfie/SelfiePage.sass';

function ValidationSpinner(): JSX.Element {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className="selfie-validation-icon__spinner"
    >
      <circle
        cx="32"
        cy="32"
        r="24"
        stroke="rgba(138, 63, 208, 0.2)"
        strokeWidth="4"
      />
      <path
        d="M32 16v16l10 6"
        stroke="#8A3FD0"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SelfieValidationIcon(): JSX.Element {
  const { t } = useTranslation(COMMON_NAMESPACE);

  return (
    <Box
      className="selfie-validation-icon"
      data-testid="selfie-validation-icon"
      role="img"
      aria-label={t('validatingAriaLabel')}
    >
      <ValidationSpinner />
    </Box>
  );
}
